<template>
  <date-picker
    v-model="localValue"
    color="gray"
    mode="date"
    :popover="{ placement: 'bottom', visibility: 'click' }"
    :min-date="min"
    :max-date="max"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <div class="date-input">
        <label :for="id">{{ label }}</label>

        <input
          placeholder="mm/dd/yyyy"
          :value="inputValue"
          :id="id"
          :name="id"
          v-on="inputEvents"
        />

        <span class="close" v-show="hasClear && localValue">
          <icon-button
            icon="close"
            size="16"
            tabindex="-1"
            @click="clear"
          />
        </span>
      </div>
    </template>
  </date-picker>
</template>

<script>
import moment from 'moment';
import DatePicker from 'v-calendar/lib/components/date-picker.umd.min';

import IconButton from './IconButton';

export default {
  components: {
    DatePicker,
    IconButton,
  },

  props: {
    value: [Date, Object, String],
    id: String,
    label: String,
    min: Date,
    hasClear: Boolean,
    max: {
      type: Date,
      default: () => new Date(),
    },
  },

  data() {
    return {
      localValue: null,
    };
  },

  mounted() {
    this.setValue();
  },

  watch: {
    value: {
      handler() {
        this.setValue();
      },
      deep: true,
    },

    localValue: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },

  methods: {
    setValue() {
      if (!this.value) {
        this.localValue = null;
      } else {
        this.localValue = this.value;
      }
    },

    clear() {
      this.localValue = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.date-input {
  margin-bottom: var(--date-input-margin-bottom, $gp);
  position: relative;

  input {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: var(--theme-background);
    border: solid 1px var(--theme-input-border);
    border-radius: $border-radius;
    outline: 0;
    font-size: 16px;
    padding: $gp * .5;
    width: 100%;
    height: 46px;
  }

  ::-webkit-inner-spin-button,
  ::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  label {
    color: $color-gray-5;
    background-color: var(--theme-background);
    font-size: 12px;
    position: absolute;
    transform-origin: top left;
    padding: 0 3px;
    transform: translate(9px, -9px);
  }

  .close {
    --theme-icon-button-color: #{$color-gray-5};
    position: absolute;
    right: 0;
    top: 0;
    height: 46px;
    padding-right: $gp * .5;
    display: inline-flex;
    align-items: center;
  }
}
</style>
